
/**
 * Shared API Configuration
 *
 * Local development:
 * Uses /api/v1 through CRA setupProxy.js.
 *
 * Firebase Hosting:
 * Uses the backend URL from .env.
 */

const BACKEND_ORIGIN = (
  process.env.REACT_APP_DOCUMENT_API_URL || ""
)
  .trim()
  .replace(/\/+$/, "");

const IS_LOCAL_DEVELOPMENT =
  process.env.NODE_ENV === "development";

export const DOCUMENT_API_ORIGIN =
  IS_LOCAL_DEVELOPMENT
    ? ""
    : BACKEND_ORIGIN;

export const DOCUMENT_API_V1 =
  `${DOCUMENT_API_ORIGIN}/api/v1`;
